module.exports = __webpack_public_path__ + "static/media/cerrarsesion.d653f317.svg";